<template>
  <span class="loader"><span class="loader-inner"></span></span>
</template>

<script>

export default {
  name: 'CommonUiLoader'
}
</script>

<style scoped>
  body, html {
      height: 100%;
      text-align: center;
  }

  body {
    background-color: #fff;
  }

  .loader {
    display: inline-block;
    width: 30px;
    height: 30px;
    position: relative;
    border: 4px solid #242F3F;
    border-radius: 0%;
    top: 50%;
    animation: loader 2s infinite ease;
  }

  .loader-inner {
    vertical-align: top;
    display: inline-block;
    width: 100%;
    background-color: #242F3F;
    animation: loader-inner 2s infinite ease-in;
  }

  @keyframes loader {
    0% {
      border-radius: 0%;
      transform: rotate(0deg);
    }

    25% {
      transform: rotate(180deg);
      border-radius: 40%;
    }

    50% {
      transform: rotate(180deg);
      border-radius: 40%;
    }

    75% {
      transform: rotate(360deg);
      border-radius: 30%;
    }

    100% {
      border-radius: 0%;
      transform: rotate(360deg);
    }
  }

  @keyframes loader-inner {
    0% {
      height: 0%;
    }

    25% {
      height: 0%;
    }

    50% {
      height: 100%;
    }

    75% {
      height: 100%;
    }

    100% {
      height: 0%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ui/loader.vue